/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangStrategicCertificationRouteImport } from './routes/$lang/strategic-certification'
import { Route as LangMlbrRouteImport } from './routes/$lang/mlbr'
import { Route as LangMissionsRouteImport } from './routes/$lang/missions'
import { Route as LangContactRouteImport } from './routes/$lang/contact'
import { Route as LangCareersRouteImport } from './routes/$lang/careers'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as LangServicesIndexRouteImport } from './routes/$lang/services/index'
import { Route as LangProductsIndexRouteImport } from './routes/$lang/products/index'
import { Route as LangServicesT8RouteImport } from './routes/$lang/services/t8'
import { Route as LangServicesManufacturingRouteImport } from './routes/$lang/services/manufacturing'
import { Route as LangServicesFtlRouteImport } from './routes/$lang/services/ftl'
import { Route as LangServicesAerospaceRouteImport } from './routes/$lang/services/aerospace'
import { Route as LangProductsReactionControlSystemRouteImport } from './routes/$lang/products/reaction-control-system'
import { Route as LangProductsOnBoardComponentsRouteImport } from './routes/$lang/products/on-board-components'
import { Route as LangProductsHtpRouteImport } from './routes/$lang/products/htp'
import { Route as LangProductsDaqRouteImport } from './routes/$lang/products/daq'
import { Route as LangProductsCatalystRouteImport } from './routes/$lang/products/catalyst'
import { Route as LangProductsBizupodRouteImport } from './routes/$lang/products/bizupod'
import { Route as LangProductsAtlasHtpRouteImport } from './routes/$lang/products/atlas-htp'
import { Route as LangProductsArionLiquidRocketEngineRouteImport } from './routes/$lang/products/arion-liquid-rocket-engine'
import { Route as LangCategoryPropulsionSystemsRouteImport } from './routes/$lang/category/propulsion-systems'
import { Route as LangCategoryEletronicSystemsRouteImport } from './routes/$lang/category/eletronic-systems'
import { Route as LangCategoryCubesatDeployerSystemRouteImport } from './routes/$lang/category/cubesat-deployer-system'
import { Route as LangCategoryChemicalsRouteImport } from './routes/$lang/category/chemicals'

const LangRoute = LangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRoute,
} as any)
const LangStrategicCertificationRoute =
  LangStrategicCertificationRouteImport.update({
    id: '/strategic-certification',
    path: '/strategic-certification',
    getParentRoute: () => LangRoute,
  } as any)
const LangMlbrRoute = LangMlbrRouteImport.update({
  id: '/mlbr',
  path: '/mlbr',
  getParentRoute: () => LangRoute,
} as any)
const LangMissionsRoute = LangMissionsRouteImport.update({
  id: '/missions',
  path: '/missions',
  getParentRoute: () => LangRoute,
} as any)
const LangContactRoute = LangContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LangRoute,
} as any)
const LangCareersRoute = LangCareersRouteImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => LangRoute,
} as any)
const LangAboutRoute = LangAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LangRoute,
} as any)
const LangServicesIndexRoute = LangServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsIndexRoute = LangProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => LangRoute,
} as any)
const LangServicesT8Route = LangServicesT8RouteImport.update({
  id: '/services/t8',
  path: '/services/t8',
  getParentRoute: () => LangRoute,
} as any)
const LangServicesManufacturingRoute =
  LangServicesManufacturingRouteImport.update({
    id: '/services/manufacturing',
    path: '/services/manufacturing',
    getParentRoute: () => LangRoute,
  } as any)
const LangServicesFtlRoute = LangServicesFtlRouteImport.update({
  id: '/services/ftl',
  path: '/services/ftl',
  getParentRoute: () => LangRoute,
} as any)
const LangServicesAerospaceRoute = LangServicesAerospaceRouteImport.update({
  id: '/services/aerospace',
  path: '/services/aerospace',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsReactionControlSystemRoute =
  LangProductsReactionControlSystemRouteImport.update({
    id: '/products/reaction-control-system',
    path: '/products/reaction-control-system',
    getParentRoute: () => LangRoute,
  } as any)
const LangProductsOnBoardComponentsRoute =
  LangProductsOnBoardComponentsRouteImport.update({
    id: '/products/on-board-components',
    path: '/products/on-board-components',
    getParentRoute: () => LangRoute,
  } as any)
const LangProductsHtpRoute = LangProductsHtpRouteImport.update({
  id: '/products/htp',
  path: '/products/htp',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsDaqRoute = LangProductsDaqRouteImport.update({
  id: '/products/daq',
  path: '/products/daq',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsCatalystRoute = LangProductsCatalystRouteImport.update({
  id: '/products/catalyst',
  path: '/products/catalyst',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsBizupodRoute = LangProductsBizupodRouteImport.update({
  id: '/products/bizupod',
  path: '/products/bizupod',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsAtlasHtpRoute = LangProductsAtlasHtpRouteImport.update({
  id: '/products/atlas-htp',
  path: '/products/atlas-htp',
  getParentRoute: () => LangRoute,
} as any)
const LangProductsArionLiquidRocketEngineRoute =
  LangProductsArionLiquidRocketEngineRouteImport.update({
    id: '/products/arion-liquid-rocket-engine',
    path: '/products/arion-liquid-rocket-engine',
    getParentRoute: () => LangRoute,
  } as any)
const LangCategoryPropulsionSystemsRoute =
  LangCategoryPropulsionSystemsRouteImport.update({
    id: '/category/propulsion-systems',
    path: '/category/propulsion-systems',
    getParentRoute: () => LangRoute,
  } as any)
const LangCategoryEletronicSystemsRoute =
  LangCategoryEletronicSystemsRouteImport.update({
    id: '/category/eletronic-systems',
    path: '/category/eletronic-systems',
    getParentRoute: () => LangRoute,
  } as any)
const LangCategoryCubesatDeployerSystemRoute =
  LangCategoryCubesatDeployerSystemRouteImport.update({
    id: '/category/cubesat-deployer-system',
    path: '/category/cubesat-deployer-system',
    getParentRoute: () => LangRoute,
  } as any)
const LangCategoryChemicalsRoute = LangCategoryChemicalsRouteImport.update({
  id: '/category/chemicals',
  path: '/category/chemicals',
  getParentRoute: () => LangRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/$lang/about': typeof LangAboutRoute
  '/$lang/careers': typeof LangCareersRoute
  '/$lang/contact': typeof LangContactRoute
  '/$lang/missions': typeof LangMissionsRoute
  '/$lang/mlbr': typeof LangMlbrRoute
  '/$lang/strategic-certification': typeof LangStrategicCertificationRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/category/chemicals': typeof LangCategoryChemicalsRoute
  '/$lang/category/cubesat-deployer-system': typeof LangCategoryCubesatDeployerSystemRoute
  '/$lang/category/eletronic-systems': typeof LangCategoryEletronicSystemsRoute
  '/$lang/category/propulsion-systems': typeof LangCategoryPropulsionSystemsRoute
  '/$lang/products/arion-liquid-rocket-engine': typeof LangProductsArionLiquidRocketEngineRoute
  '/$lang/products/atlas-htp': typeof LangProductsAtlasHtpRoute
  '/$lang/products/bizupod': typeof LangProductsBizupodRoute
  '/$lang/products/catalyst': typeof LangProductsCatalystRoute
  '/$lang/products/daq': typeof LangProductsDaqRoute
  '/$lang/products/htp': typeof LangProductsHtpRoute
  '/$lang/products/on-board-components': typeof LangProductsOnBoardComponentsRoute
  '/$lang/products/reaction-control-system': typeof LangProductsReactionControlSystemRoute
  '/$lang/services/aerospace': typeof LangServicesAerospaceRoute
  '/$lang/services/ftl': typeof LangServicesFtlRoute
  '/$lang/services/manufacturing': typeof LangServicesManufacturingRoute
  '/$lang/services/t8': typeof LangServicesT8Route
  '/$lang/products/': typeof LangProductsIndexRoute
  '/$lang/services/': typeof LangServicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/careers': typeof LangCareersRoute
  '/$lang/contact': typeof LangContactRoute
  '/$lang/missions': typeof LangMissionsRoute
  '/$lang/mlbr': typeof LangMlbrRoute
  '/$lang/strategic-certification': typeof LangStrategicCertificationRoute
  '/$lang': typeof LangIndexRoute
  '/$lang/category/chemicals': typeof LangCategoryChemicalsRoute
  '/$lang/category/cubesat-deployer-system': typeof LangCategoryCubesatDeployerSystemRoute
  '/$lang/category/eletronic-systems': typeof LangCategoryEletronicSystemsRoute
  '/$lang/category/propulsion-systems': typeof LangCategoryPropulsionSystemsRoute
  '/$lang/products/arion-liquid-rocket-engine': typeof LangProductsArionLiquidRocketEngineRoute
  '/$lang/products/atlas-htp': typeof LangProductsAtlasHtpRoute
  '/$lang/products/bizupod': typeof LangProductsBizupodRoute
  '/$lang/products/catalyst': typeof LangProductsCatalystRoute
  '/$lang/products/daq': typeof LangProductsDaqRoute
  '/$lang/products/htp': typeof LangProductsHtpRoute
  '/$lang/products/on-board-components': typeof LangProductsOnBoardComponentsRoute
  '/$lang/products/reaction-control-system': typeof LangProductsReactionControlSystemRoute
  '/$lang/services/aerospace': typeof LangServicesAerospaceRoute
  '/$lang/services/ftl': typeof LangServicesFtlRoute
  '/$lang/services/manufacturing': typeof LangServicesManufacturingRoute
  '/$lang/services/t8': typeof LangServicesT8Route
  '/$lang/products': typeof LangProductsIndexRoute
  '/$lang/services': typeof LangServicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/$lang/about': typeof LangAboutRoute
  '/$lang/careers': typeof LangCareersRoute
  '/$lang/contact': typeof LangContactRoute
  '/$lang/missions': typeof LangMissionsRoute
  '/$lang/mlbr': typeof LangMlbrRoute
  '/$lang/strategic-certification': typeof LangStrategicCertificationRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/category/chemicals': typeof LangCategoryChemicalsRoute
  '/$lang/category/cubesat-deployer-system': typeof LangCategoryCubesatDeployerSystemRoute
  '/$lang/category/eletronic-systems': typeof LangCategoryEletronicSystemsRoute
  '/$lang/category/propulsion-systems': typeof LangCategoryPropulsionSystemsRoute
  '/$lang/products/arion-liquid-rocket-engine': typeof LangProductsArionLiquidRocketEngineRoute
  '/$lang/products/atlas-htp': typeof LangProductsAtlasHtpRoute
  '/$lang/products/bizupod': typeof LangProductsBizupodRoute
  '/$lang/products/catalyst': typeof LangProductsCatalystRoute
  '/$lang/products/daq': typeof LangProductsDaqRoute
  '/$lang/products/htp': typeof LangProductsHtpRoute
  '/$lang/products/on-board-components': typeof LangProductsOnBoardComponentsRoute
  '/$lang/products/reaction-control-system': typeof LangProductsReactionControlSystemRoute
  '/$lang/services/aerospace': typeof LangServicesAerospaceRoute
  '/$lang/services/ftl': typeof LangServicesFtlRoute
  '/$lang/services/manufacturing': typeof LangServicesManufacturingRoute
  '/$lang/services/t8': typeof LangServicesT8Route
  '/$lang/products/': typeof LangProductsIndexRoute
  '/$lang/services/': typeof LangServicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/$lang/about'
    | '/$lang/careers'
    | '/$lang/contact'
    | '/$lang/missions'
    | '/$lang/mlbr'
    | '/$lang/strategic-certification'
    | '/$lang/'
    | '/$lang/category/chemicals'
    | '/$lang/category/cubesat-deployer-system'
    | '/$lang/category/eletronic-systems'
    | '/$lang/category/propulsion-systems'
    | '/$lang/products/arion-liquid-rocket-engine'
    | '/$lang/products/atlas-htp'
    | '/$lang/products/bizupod'
    | '/$lang/products/catalyst'
    | '/$lang/products/daq'
    | '/$lang/products/htp'
    | '/$lang/products/on-board-components'
    | '/$lang/products/reaction-control-system'
    | '/$lang/services/aerospace'
    | '/$lang/services/ftl'
    | '/$lang/services/manufacturing'
    | '/$lang/services/t8'
    | '/$lang/products/'
    | '/$lang/services/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang/about'
    | '/$lang/careers'
    | '/$lang/contact'
    | '/$lang/missions'
    | '/$lang/mlbr'
    | '/$lang/strategic-certification'
    | '/$lang'
    | '/$lang/category/chemicals'
    | '/$lang/category/cubesat-deployer-system'
    | '/$lang/category/eletronic-systems'
    | '/$lang/category/propulsion-systems'
    | '/$lang/products/arion-liquid-rocket-engine'
    | '/$lang/products/atlas-htp'
    | '/$lang/products/bizupod'
    | '/$lang/products/catalyst'
    | '/$lang/products/daq'
    | '/$lang/products/htp'
    | '/$lang/products/on-board-components'
    | '/$lang/products/reaction-control-system'
    | '/$lang/services/aerospace'
    | '/$lang/services/ftl'
    | '/$lang/services/manufacturing'
    | '/$lang/services/t8'
    | '/$lang/products'
    | '/$lang/services'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/$lang/about'
    | '/$lang/careers'
    | '/$lang/contact'
    | '/$lang/missions'
    | '/$lang/mlbr'
    | '/$lang/strategic-certification'
    | '/$lang/'
    | '/$lang/category/chemicals'
    | '/$lang/category/cubesat-deployer-system'
    | '/$lang/category/eletronic-systems'
    | '/$lang/category/propulsion-systems'
    | '/$lang/products/arion-liquid-rocket-engine'
    | '/$lang/products/atlas-htp'
    | '/$lang/products/bizupod'
    | '/$lang/products/catalyst'
    | '/$lang/products/daq'
    | '/$lang/products/htp'
    | '/$lang/products/on-board-components'
    | '/$lang/products/reaction-control-system'
    | '/$lang/services/aerospace'
    | '/$lang/services/ftl'
    | '/$lang/services/manufacturing'
    | '/$lang/services/t8'
    | '/$lang/products/'
    | '/$lang/services/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRoute: typeof LangRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/strategic-certification': {
      id: '/$lang/strategic-certification'
      path: '/strategic-certification'
      fullPath: '/$lang/strategic-certification'
      preLoaderRoute: typeof LangStrategicCertificationRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/mlbr': {
      id: '/$lang/mlbr'
      path: '/mlbr'
      fullPath: '/$lang/mlbr'
      preLoaderRoute: typeof LangMlbrRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/missions': {
      id: '/$lang/missions'
      path: '/missions'
      fullPath: '/$lang/missions'
      preLoaderRoute: typeof LangMissionsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/contact': {
      id: '/$lang/contact'
      path: '/contact'
      fullPath: '/$lang/contact'
      preLoaderRoute: typeof LangContactRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/careers': {
      id: '/$lang/careers'
      path: '/careers'
      fullPath: '/$lang/careers'
      preLoaderRoute: typeof LangCareersRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/about': {
      id: '/$lang/about'
      path: '/about'
      fullPath: '/$lang/about'
      preLoaderRoute: typeof LangAboutRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/services/': {
      id: '/$lang/services/'
      path: '/services'
      fullPath: '/$lang/services/'
      preLoaderRoute: typeof LangServicesIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/': {
      id: '/$lang/products/'
      path: '/products'
      fullPath: '/$lang/products/'
      preLoaderRoute: typeof LangProductsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/services/t8': {
      id: '/$lang/services/t8'
      path: '/services/t8'
      fullPath: '/$lang/services/t8'
      preLoaderRoute: typeof LangServicesT8RouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/services/manufacturing': {
      id: '/$lang/services/manufacturing'
      path: '/services/manufacturing'
      fullPath: '/$lang/services/manufacturing'
      preLoaderRoute: typeof LangServicesManufacturingRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/services/ftl': {
      id: '/$lang/services/ftl'
      path: '/services/ftl'
      fullPath: '/$lang/services/ftl'
      preLoaderRoute: typeof LangServicesFtlRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/services/aerospace': {
      id: '/$lang/services/aerospace'
      path: '/services/aerospace'
      fullPath: '/$lang/services/aerospace'
      preLoaderRoute: typeof LangServicesAerospaceRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/reaction-control-system': {
      id: '/$lang/products/reaction-control-system'
      path: '/products/reaction-control-system'
      fullPath: '/$lang/products/reaction-control-system'
      preLoaderRoute: typeof LangProductsReactionControlSystemRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/on-board-components': {
      id: '/$lang/products/on-board-components'
      path: '/products/on-board-components'
      fullPath: '/$lang/products/on-board-components'
      preLoaderRoute: typeof LangProductsOnBoardComponentsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/htp': {
      id: '/$lang/products/htp'
      path: '/products/htp'
      fullPath: '/$lang/products/htp'
      preLoaderRoute: typeof LangProductsHtpRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/daq': {
      id: '/$lang/products/daq'
      path: '/products/daq'
      fullPath: '/$lang/products/daq'
      preLoaderRoute: typeof LangProductsDaqRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/catalyst': {
      id: '/$lang/products/catalyst'
      path: '/products/catalyst'
      fullPath: '/$lang/products/catalyst'
      preLoaderRoute: typeof LangProductsCatalystRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/bizupod': {
      id: '/$lang/products/bizupod'
      path: '/products/bizupod'
      fullPath: '/$lang/products/bizupod'
      preLoaderRoute: typeof LangProductsBizupodRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/atlas-htp': {
      id: '/$lang/products/atlas-htp'
      path: '/products/atlas-htp'
      fullPath: '/$lang/products/atlas-htp'
      preLoaderRoute: typeof LangProductsAtlasHtpRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/products/arion-liquid-rocket-engine': {
      id: '/$lang/products/arion-liquid-rocket-engine'
      path: '/products/arion-liquid-rocket-engine'
      fullPath: '/$lang/products/arion-liquid-rocket-engine'
      preLoaderRoute: typeof LangProductsArionLiquidRocketEngineRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/category/propulsion-systems': {
      id: '/$lang/category/propulsion-systems'
      path: '/category/propulsion-systems'
      fullPath: '/$lang/category/propulsion-systems'
      preLoaderRoute: typeof LangCategoryPropulsionSystemsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/category/eletronic-systems': {
      id: '/$lang/category/eletronic-systems'
      path: '/category/eletronic-systems'
      fullPath: '/$lang/category/eletronic-systems'
      preLoaderRoute: typeof LangCategoryEletronicSystemsRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/category/cubesat-deployer-system': {
      id: '/$lang/category/cubesat-deployer-system'
      path: '/category/cubesat-deployer-system'
      fullPath: '/$lang/category/cubesat-deployer-system'
      preLoaderRoute: typeof LangCategoryCubesatDeployerSystemRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/category/chemicals': {
      id: '/$lang/category/chemicals'
      path: '/category/chemicals'
      fullPath: '/$lang/category/chemicals'
      preLoaderRoute: typeof LangCategoryChemicalsRouteImport
      parentRoute: typeof LangRoute
    }
  }
}

interface LangRouteChildren {
  LangAboutRoute: typeof LangAboutRoute
  LangCareersRoute: typeof LangCareersRoute
  LangContactRoute: typeof LangContactRoute
  LangMissionsRoute: typeof LangMissionsRoute
  LangMlbrRoute: typeof LangMlbrRoute
  LangStrategicCertificationRoute: typeof LangStrategicCertificationRoute
  LangIndexRoute: typeof LangIndexRoute
  LangCategoryChemicalsRoute: typeof LangCategoryChemicalsRoute
  LangCategoryCubesatDeployerSystemRoute: typeof LangCategoryCubesatDeployerSystemRoute
  LangCategoryEletronicSystemsRoute: typeof LangCategoryEletronicSystemsRoute
  LangCategoryPropulsionSystemsRoute: typeof LangCategoryPropulsionSystemsRoute
  LangProductsArionLiquidRocketEngineRoute: typeof LangProductsArionLiquidRocketEngineRoute
  LangProductsAtlasHtpRoute: typeof LangProductsAtlasHtpRoute
  LangProductsBizupodRoute: typeof LangProductsBizupodRoute
  LangProductsCatalystRoute: typeof LangProductsCatalystRoute
  LangProductsDaqRoute: typeof LangProductsDaqRoute
  LangProductsHtpRoute: typeof LangProductsHtpRoute
  LangProductsOnBoardComponentsRoute: typeof LangProductsOnBoardComponentsRoute
  LangProductsReactionControlSystemRoute: typeof LangProductsReactionControlSystemRoute
  LangServicesAerospaceRoute: typeof LangServicesAerospaceRoute
  LangServicesFtlRoute: typeof LangServicesFtlRoute
  LangServicesManufacturingRoute: typeof LangServicesManufacturingRoute
  LangServicesT8Route: typeof LangServicesT8Route
  LangProductsIndexRoute: typeof LangProductsIndexRoute
  LangServicesIndexRoute: typeof LangServicesIndexRoute
}

const LangRouteChildren: LangRouteChildren = {
  LangAboutRoute: LangAboutRoute,
  LangCareersRoute: LangCareersRoute,
  LangContactRoute: LangContactRoute,
  LangMissionsRoute: LangMissionsRoute,
  LangMlbrRoute: LangMlbrRoute,
  LangStrategicCertificationRoute: LangStrategicCertificationRoute,
  LangIndexRoute: LangIndexRoute,
  LangCategoryChemicalsRoute: LangCategoryChemicalsRoute,
  LangCategoryCubesatDeployerSystemRoute:
    LangCategoryCubesatDeployerSystemRoute,
  LangCategoryEletronicSystemsRoute: LangCategoryEletronicSystemsRoute,
  LangCategoryPropulsionSystemsRoute: LangCategoryPropulsionSystemsRoute,
  LangProductsArionLiquidRocketEngineRoute:
    LangProductsArionLiquidRocketEngineRoute,
  LangProductsAtlasHtpRoute: LangProductsAtlasHtpRoute,
  LangProductsBizupodRoute: LangProductsBizupodRoute,
  LangProductsCatalystRoute: LangProductsCatalystRoute,
  LangProductsDaqRoute: LangProductsDaqRoute,
  LangProductsHtpRoute: LangProductsHtpRoute,
  LangProductsOnBoardComponentsRoute: LangProductsOnBoardComponentsRoute,
  LangProductsReactionControlSystemRoute:
    LangProductsReactionControlSystemRoute,
  LangServicesAerospaceRoute: LangServicesAerospaceRoute,
  LangServicesFtlRoute: LangServicesFtlRoute,
  LangServicesManufacturingRoute: LangServicesManufacturingRoute,
  LangServicesT8Route: LangServicesT8Route,
  LangProductsIndexRoute: LangProductsIndexRoute,
  LangServicesIndexRoute: LangServicesIndexRoute,
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRoute: LangRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
